import React from 'react';
import PropTypes from 'prop-types';
import { getPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { DEFAULT_PRICE } from 'site-modules/shared/components/deal/deal-constants';

export function DealerPrice({ dealerPrice = 0 }) {
  return (
    <div className="heading-2 mb-0">
      {dealerPrice ? (
        <span data-test="vdp-price-row" data-testid="vdp-price-row">
          {getPriceStringV2(dealerPrice)}
        </span>
      ) : (
        <span className="fw-normal">{DEFAULT_PRICE}</span>
      )}
    </div>
  );
}

DealerPrice.propTypes = {
  dealerPrice: PropTypes.number,
};
